export default {
	data: {
		selectedImageIndex: undefined,
		openstreetmap: false
	},
	beforeMount: function () {

		this.checkOsmConsent();

		var url = new URL(window.location.href);
		var params = {};
		for (let key of url.searchParams.keys()) {
			params[key] = url.searchParams.get(key);

		}
		this.searchParams = params;
	},
	mounted: function () {
		window.addEventListener('ccm19WidgetClosed', (event) => {
			this.checkOsmConsent();
		});
	},
	computed: {

		mailto: function () {
			return `mailto:${this.emailAddress}`;
		},
		emailAddress: function () {
			return (VOFFICE.contactEmail || ['info', 'test.de']).join('@');
		},
	},

	methods: {

		checkOsmConsent: function () {
			const suffix = VOFFICE.token.substr(VOFFICE.token.length - 12);
			var cookieName = 'allowOpenstreetmap_' + suffix;
			const allowOpenstreet = this.getCookie(cookieName);
			if (allowOpenstreet) {
				this.openstreetmap = true;
			} else {
				const data = CCM.acceptedEmbeddings;
				const targetName = "OpenStreetMap";
				const entry = data.find(item => item.name === targetName);


				if (entry) {
					this.openstreetmap = true;
				} else {
					this.openstreetmap = false;
				}
			}
		},

		getCookie: function (name) {
			const nameEQ = name + "=";
			const ca = document.cookie.split(';');
			for (let i = 0; i < ca.length; i++) {
				let c = ca[i];
				while (c.charAt(0) === ' ') c = c.substring(1, c.length);
				if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
			}
			return null;
		},

		setCookie: function (name, value, days) {
			const date = new Date();
			date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
			const expires = "expires=" + date.toUTCString();
			document.cookie = name + "=" + value + ";" + expires + ";path=/";
		},

		allowOpenstreetmap: function () {
			const suffix = VOFFICE.token.substr(VOFFICE.token.length - 12);
			var cookieName = 'allowOpenstreetmap_' + suffix;
			this.setCookie(cookieName, true, VOFFICE.settings.osmCookieDays);
			this.openstreetmap = true;
		},

		showOpenstreetmap: function () {
			this.openstreetmap = true;
		},
		getBlogPath: function (jsonData) {

			const data = typeof jsonData === "string" ? JSON.parse(jsonData) : jsonData;
			for (const item of data) {
				switch (item.name) {
				case "Stellenangebot":
					return "./stellenangebote";
				case "Angebote":
					return "./angebote";
				case "Saison":
					return "./saisonzeiten";
				case "Eigentuemer":
					return "./eigentuemer";
				case "Preise":
					return "./preise";
				default:
					console.log(`Kein spezifischer Fall für: ${item.name}`);
					break;
				}
			}

			return './blog';
		},
		getBlogPathName: function (jsonData) {
			const data = typeof jsonData === "string" ? JSON.parse(jsonData) : jsonData;

			for (const item of data) {
				switch (item.name) {
				case "Stellenangebot":
					return "Stellenangebote";
				case "Angebote":
					return "Angebote";
				case "Saison":
					return "Saisonzeiten";
				case "Eigentuemer":
					return "Eigentümer";
				case "Preise":
					return "Preise";
				default:
					console.log(`Kein spezifischer Fall für: ${item.name}`);
					break;
				}
			}

			// Falls kein passender Wert gefunden wurde, Standardwert zurückgeben
			return "Blog";
		}
	},

};